import { ChatBotService } from "@/components/ChatBot/chat-bot.service";

class RecordStream {
  constructor(private _ws = new ChatBotService()) {}
  rec: any = {} as MediaRecorder;
  stream: any = {};
  data: any = [];

  async startStreaming(recorded: boolean): Promise<void> {
    await navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((e) => {
        this.stream = e;
        if (this.stream) {
          this.recordStart(recorded);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  stopStreaming(): void {
    if (this.stream) {
      this.stream.getAudioTracks()[0].stop();
    }
  }

  recordStart(recorded: boolean): void {
    const recStream = new MediaRecorder(this.stream);
    this.rec = recStream;
    this.data.length = 0;
    this.rec?.start();
    recorded = true;
  }

  recordStop(recorded: boolean): void {
    this.rec?.stop();
    recorded = false;
    this.rec.ondataavailable = (e) => {
      this.data.push(e.data);
    };
    this.rec.onstop = () => {
      new Blob(this.data).arrayBuffer().then((buffer) => {
        let encoder = new TextEncoder().encode("liked");
        let arr1 = new Uint8Array(encoder.buffer);
        let arr2 = new Uint8Array([0x1, arr1.length]);
        let arr3 = new Uint8Array(buffer);
        let concat = new Uint8Array(arr1.length + arr2.length + arr3.length);
        concat.set(arr2);
        concat.set(arr2, arr1.length);
        concat.set(arr3, arr1.length + arr2.length);
        this._ws.sendBlobMessage(new Blob([concat.buffer]));
      });
    };
    this.stopStreaming();
  }
}

export { RecordStream };
